<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">
        Register {{ data.paymentMethod === 'UC' ? 'Credit Card' : 'Bank Account' }}
      </h3>
    </div>
  </div>
  <div class="form">
    <div class="card-body">
      <div class="form-group row" [formGroup]="form">
        <div class="col-lg-12">
          <mat-form-field appearance="outline" class="mat-form-field-fluid">
            <mat-label>{{
              data.paymentMethod === 'UC' ? 'Card Number' : 'Account Number'
            }}</mat-label>
            <input
              formControlName="firstInsertion"
              matInput
              mask="{{ data.paymentMethod === 'UC' ? '0000 0000 0000 0000' : '00000000000000000' }}"
              required
            />
            <mat-error *ngIf="firstInsertion.invalid">{{
              getErrorMessage('firstInsertion', 'required') ||
                getErrorMessage('firstInsertion', 'pattern')
            }}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="mat-form-field-fluid">
            <mat-label>{{ data.paymentMethod === 'UC' ? 'Exp Date' : 'User ABA' }}</mat-label>
            <input
              matInput
              formControlName="secondInsertion"
              placeholder="{{ data.paymentMethod === 'UC' ? 'MM/YYYY' : 'Insert ABA' }}"
              mask="{{ data.paymentMethod === 'UC' ? '00/0000' : 'AAAAAAAAA' }} "
              required
            />
            <mat-error *ngIf="secondInsertion.invalid">{{
              getErrorMessage('secondInsertion', 'required') ||
                getErrorMessage('secondInsertion', 'pattern')
            }}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button
            type="button"
            mat-raised-button
            color="secondary"
            mat-button
            (click)="onNoClick()"
          >
            Cancel</button
          >&nbsp;
          <button
            type="button"
            mat-raised-button
            color="primary"
            mat-button
            (click)="onSubmitClick()"
            color="primary"
            cdkFocusInitial
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
